import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const PrivateRoute = () => {
  const { user, loading } = useContext(AuthContext);
  const location = useLocation();

  // 🔄 Încă se încarcă userul din context
  if (loading) {
    return null;
  }

  const token = localStorage.getItem("token");

  // ✅ Condiție dublă: user există și token este prezent
  const isAuthenticated = user && token;

  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default PrivateRoute;